import { WithdrawalResponseDto } from "../dto/response/withdrawal-response-dto";
import { Withdrawal } from "../model/withdrawal.model";

export function fromWithdrawalResponseDtoToWithdrawal(
  dto: WithdrawalResponseDto
): Withdrawal {
  const dataArray = dto.data.map((withdrawal) => ({
    id: withdrawal.id,
    walletId: withdrawal.walletId,
    amount: withdrawal.amount,
    status: withdrawal.status,
    pixKey: withdrawal.pixKey,
    pixKeyType: withdrawal.pixKeyType,
    txId: withdrawal.txId,
    createdAt: withdrawal.createdAt,
    fee: withdrawal.fee,
    finalAmount: withdrawal.finalAmount}));

  return {
    data: {
      [dto.pagination.page]: dataArray},
    pagination: {
      total: dto.pagination.total,
      page: dto.pagination.page,
      pageSize: dto.pagination.pageSize,
      totalPage: dto.pagination.totalPage}};
}
